import { render, staticRenderFns } from "./create-loading.vue?vue&type=template&id=525f1b7c&scoped=true"
import script from "./create-loading.vue?vue&type=script&lang=js"
export * from "./create-loading.vue?vue&type=script&lang=js"
import style0 from "./create-loading.vue?vue&type=style&index=0&id=525f1b7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_4rliqqz3ui7xo7iaw2ukiguuga/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525f1b7c",
  null
  
)

export default component.exports